import { makeObservable, observable, flow, action, computed } from "mobx";
import { toast } from "sonner";

import { api } from "@/lib/services";
import { ApiRoutes } from "@/lib/routes";

import UpdateAuditRegistrySchema from "@/areas/settings/schemas/UpdateAuditRegistrySchema";

export default class UpdateAuditRegistryStore {
  visible = false;
  processing = false;

  constructor(parentStore) {
    makeObservable(this, {
      visible: observable,
      processing: observable,
      show: action,
      hide: action,
      toggle: action,
      save: flow,
      canEdit: computed,
    });

    this.parentStore = parentStore;
  }

  show() {
    this.visible = true;
  }

  hide() {
    this.visible = false;
  }

  toggle(visible) {
    this.visible = visible === true ? true : visible === false ? false : !this.visible;
  }

  get canEdit() {
    return (
      this.parentStore.auditRegistryPermissionStore.isCoordinator ||
      this.parentStore.auditRegistryPermissionStore.isResponsible
    );
  }

  *save(data, options) {
    try {
      this.processing = true;

      const parseResult = UpdateAuditRegistrySchema.safeParse(data);
      if (!parseResult.success) {
        return parseResult;
      }

      const response = yield api.put(ApiRoutes.forAuditRegistry(data.id), data);
      if (response.status == 202) {
        this.visible = false;
        toast.success("Audit registry updated successfully");
        this.parentStore.load({ id: data.id });

        return { success: true, data: response.data };
      } else {
        throw new Error("Unexpected error code");
      }
    } catch (e) {
      toast.error("Error while updating registry", {
        description: "Unexpected error, please try again later.",
      });
      return { success: false, error: e };
    } finally {
      this.processing = false;
    }
  }
}
